export const LOW_SOC = 45
export const MID_SOC = 60
export const HIG_SOC = 80
export const MAX_SOC = 100